import { Box, Grid, Paper, Typography } from '@mui/material';
import { Field, useForm } from 'react-final-form';
import { useEffect } from 'react';
import { FORM, STRINGS } from '../../../constants';
import {
  ACCEPT_IMAGE_MIME_TYPE,
  MAX_IMAGE_SIZE,
  MAX_IMAGES_UPLOAD_LIMIT,
  MULTILINE_FIELDS,
} from '../constants';
import { StringUtil } from '../../../utils';
import ImageDropzone from '../../../components/ImageDropzone/ImageDropzone';
import { isDamagedFlow } from '../helpers';
import { NormalizerHelpers } from '../../../helpers';
import { FormInput } from '../../../components/FormInput';
import { HELP_LABELS } from '../../../constants/strings';
import DropzoneInnerText from './DropzoneInnerText';

const ClaimDetails = ({ issueType, isAvailable }) => {
  const form = useForm();
  const formFieldsConfig = FORM.HELP_FIELDS[issueType];
  const formFieldsKeys = Object.keys(formFieldsConfig);

  useEffect(() => {
    form.change(FORM.HELP_KEYS.GOODS_VALUE, ''); // solves the overlapping problem
  }, [form, issueType]);

  return (
    <Paper sx={{ p: 2, mb: 2, mt: 2, opacity: isAvailable ? 1 : 0.4 }}>
      <Typography variant='h3' sx={{ mb: 1 }}>
        {isDamagedFlow(issueType)
          ? STRINGS.TELL_ABOUT_DAMAGE
          : STRINGS.TELL_ABOUT_PARCEL}
      </Typography>
      {formFieldsKeys.map(fieldKey => {
        const fieldName = formFieldsConfig[fieldKey].KEY;
        const fieldLabel = formFieldsConfig[fieldKey].LABEL;
        const fieldPlaceholder = formFieldsConfig[fieldKey].PLACEHOLDER;
        const isRequired = formFieldsConfig[fieldKey].REQUIRED;
        const maxLength = formFieldsConfig[fieldKey].MAX_LENGTH;

        return (
          <Grid sx={{ mt: 2 }} key={fieldLabel} size={12}>
            <FormInput
              disabled={!isAvailable}
              name={fieldName}
              label={fieldLabel}
              placeholder={fieldPlaceholder}
              size='small'
              required={isRequired}
              inputProps={{ maxLength }}
              InputLabelProps={{
                style:
                  fieldLabel === HELP_LABELS.DAMAGE_DETAIL
                    ? { whiteSpace: 'pre-wrap' }
                    : {},
              }}
              fullWidth
              {...(MULTILINE_FIELDS.includes(fieldName) && {
                multiline: true,
                rows: 4,
              })}
              fieldProps={
                fieldName === FORM.HELP_KEYS.GOODS_VALUE && {
                  parse: value =>
                    NormalizerHelpers.formatAndConstrainDecimal({
                      value,
                      maxIntegerLength: 4,
                    }),
                  format: value =>
                    StringUtil.formatPrice(
                      StringUtil.formatDecimalString(value)
                    ),
                  formatOnBlur: true,
                }
              }
            />
          </Grid>
        );
      })}
      <Box sx={{ mt: 2 }}>
        <Typography variant='body2' sx={{ mb: 1 }}>
          {isDamagedFlow(issueType)
            ? STRINGS.UPLOAD_IMAGES_OF_DAMAGE
            : STRINGS.UPLOAD_FILES}
        </Typography>
        <Field
          component={ImageDropzone}
          name={FORM.HELP_KEYS.ATTACHED_IMAGES}
          disabled={!isAvailable}
          accept={ACCEPT_IMAGE_MIME_TYPE}
          maxSize={MAX_IMAGE_SIZE}
          maxFiles={MAX_IMAGES_UPLOAD_LIMIT}
          innerContent={<DropzoneInnerText />}
          showErrors
          showPreview
        />
      </Box>
    </Paper>
  );
};

export default ClaimDetails;
